<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Customers</h2>
    <div class="button-group">
      @if (selectedCustomers.length > 0) {
        <button mat-raised-button color="warn" (click)="onBulkDelete()">
          <mat-icon>delete</mat-icon>
          Delete {{ selectedCustomers.length }} selected
        </button>
      }
      <button mat-raised-button color="primary" (click)="onCreateCustomer()">
        <mat-icon>add</mat-icon>
        Add Customer
      </button>
    </div>
  </div>
  <app-generic-list
    [items]="customers"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50, 100]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [sortActive]="'userName'"
    [sortDirection]="'asc'"
    [enableEdit]="true"
    [enableDelete]="true"
    [enableSelection]="true"
    (editClick)="onEditCustomer($event)"
    (deleteClick)="onDeleteCustomer($event)"
    (selectionChange)="onSelectionChange($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)">
  </app-generic-list>
</div>
